<template>
  <div class="email-container">
    <!-- :show-unread-count="true"  -->
    <UserListSidebar :selected-user="selectedUserInfo" title="邮件用户" @select-user="checkItem"
      />
    <!-- 拖拽条 -->
    <div class="resize-handle" @mousedown="startResize($event)" @touchstart="startResize($event)"></div>
    <div v-if="!emailDetailListShow" class="right-panel bg-lightgray3 pd-x-20 border-box"
      :style="{ width: rightWidth + '%' }">
      <div class="flex between middle w100">
        <el-tabs class="w100 custom-tabs" v-model="activeName">
          <!-- <el-tab-pane label="收件箱" name="first"> -->
          <!-- 邮件分类标签 -->
          <div class="email-tabs-container">
            <div class="email-tabs-scroll">
              <div v-for="tab in emailTabs" :key="tab.type" class="email-tab-item pointer"
                @click="handleEmailTabClick(tab.type)" :class="{ active: currentEmailType === tab.type }">
                <div class="tab-content">
                  <img v-if="tab.icon" :src="tab.icon" alt="" class="tab-icon" />
                  <span>{{ tab.label }}</span>
                </div>
                <div class="tab-line" :class="{ active: currentEmailType === tab.type }"></div>
              </div>
            </div>
          </div>
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane label="发件箱" name="second"></el-tab-pane> -->
        </el-tabs>
      </div>
      <!-- 邮件工具栏 -->
      <div v-if="checkItemInfo.platformUserId" class="email-toolbar">
        <div class="toolbar-left">
          <label class="select-all-checkbox">
            <input type="checkbox" v-model="selectAll" @change="handleSelectAll" />
            <span class="checkmark"></span>
            选择全部
          </label>
          <div class="filter-buttons">
            <button class="filter-btn" :class="{ active: currentFilter === 'all' }" @click="setFilter('all')">
              全部
            </button>
            <button class="filter-btn" :class="{ active: currentFilter === 'unread' }" @click="setFilter('unread')">
              未读
            </button>
            <button class="filter-btn" :class="{ active: currentFilter === 'unanswered' }"
              @click="setFilter('unanswered')">
              未回复
            </button>
          </div>
        </div>
        <div class="toolbar-right">
          <el-button type="danger" plain size="small" @click="deleteSelected" :disabled="!hasSelectedItems">
            删除选中
          </el-button>
          <el-dropdown @command="handleMoreActions" trigger="click">
            <el-button size="small" plain>
              更多操作
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="markAsRead">标记为已读</el-dropdown-item>
              <el-dropdown-item command="markAsNew">标记为未读</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="scroll-y" style="height: calc(100vh - 200px)">
        <!-- 未选择用户时的占位 -->
        <div v-if="!checkItemInfo.platformUserId" class="empty-state">
          <div class="empty-content">
            <div class="empty-icon">
              <img src="@/assets/logo/128x128.png" alt="" />
            </div>
            <div class="empty-title">欢迎使用XChatSpace</div>
            <div class="empty-subtitle">请选择左侧用户查看邮件</div>
          </div>
        </div>

        <div v-else-if="emailList.length === 0 && !emailLoading" class="flex column center h-300">
          <div class="fs-16 color-gray">暂无邮件数据</div>
        </div>

        <ul v-else v-infinite-scroll="loadMoreEmails" :infinite-scroll-disabled="emailLoading || !hasMore"
          :infinite-scroll-distance="10" :infinite-scroll-immediate="false" class="infinite-list">
          <li v-for="(item, index) in emailList" :key="item.uid" class="infinite-list-item">
            <div class="email-item-container" 
              :class="{ 'loading-user-info': !isUserInfoLoaded(item) }"
              @click="handleEmailItemClick(item)">
              <div class="flex row middle between">
                <div class="flex row middle">
                  <!-- 复选框 -->
                  <div class="email-checkbox" @click.stop>
                    <label class="checkbox-label">
                      <input type="checkbox" :checked="selectedEmails.includes(item)"
                        @change="toggleEmailSelection(item)" />
                      <span class="checkbox-mark"></span>
                    </label>
                  </div>

                  <!-- 收藏 -->
                  <div class="mr-12">
                    <i class="el-icon-loading fs-20 pd-2" v-if="item.isToggleStar === true"></i>
                    <img v-else :src="item.isStarred
                      ? require('@/assets/svg/star-active.svg')
                      : require('@/assets/svg/star.svg')
                      " class="w-24 h-24 pointer" @click.stop="toggleStar(item)" alt="star" />
                  </div>

                  <!-- 左侧：头像和用户信息 -->
                  <div class="email-item-left flex row middle">
                    <div class="user-avatar-container">
                      <img class="user-avatar" :src="item.userDetail?.avatar_small ||
                        require('@/assets/profile.png')
                        " alt="" />
                      <div class="online-indicator" :class="item.userDetail?.is_online ? 'online' : 'offline'
                        "></div>
                    </div>
                    <div>
                      <div class="user-info flex row middle">
                        <div class="fs-16 color-black mr-16">
                          <span v-if="!item.userDetail || !item.userDetail.name || !item.userDetail.age"
                            class="loading-placeholder">
                            <i class="el-icon-loading"></i> 加载中...
                          </span>
                          <span v-else>
                            {{
                              item.userDetail.name + '，' + item.userDetail.age
                            }}
                          </span>
                        </div>
                        <div class="fs-16 bold color-gray">
                          {{ item.correspondence.count }} 邮件总数
                        </div>
                      </div>
                      <div class="flex row middle mt-8">
                        <div v-if="item.correspondence.last.status === 'unread'"
                          class="fit-content bg---red-20 color-black flex row middle pd-y-2 pd-x-10 br-50">
                          <img src="@/assets/svg/unread.svg" class="fs-16 mr-4" alt="unread" />
                          <span>未读</span>
                        </div>
                        <div v-else class="fit-content bg---green-20 color-black flex row middle pd-y-2 pd-x-10 br-50">
                          <img src="@/assets/svg/read.svg" class="fs-16 mr-4" alt="read" />
                          <span>已读</span>
                        </div>

                        <div v-if="item.correspondence.hasTrustedUserNew === true"
                          class="fit-content bg---orange-300 color-fff flex row middle pd-y-2 pd-x-16 br-4 ml-16">
                          <span>新</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex row middle email-item-right mr-10">
                  <div class="fs-14 flex row middle" :class="item.messagesLeft > 0 ? 'color-green2' : 'color-gray'
                    ">
                    <div class="flex row middle pd-y-4 pd-x-8 br-50 mr-8" :class="item.messagesLeft > 0 ? 'bg---green-20' : 'bg---gray-20'
                      ">
                      <img :src="item.messagesLeft > 0
                        ? require('@/assets/svg/mails-active.svg')
                        : require('@/assets/svg/mails.svg')
                        " class="mr-4 w-16 h-16" alt="available" />
                      <span>{{ item.messagesLeft || 0 }} </span>
                    </div>
                    {{ item.messagesLeft > 0 ? '' : '不' }}可回复
                  </div>
                  <div class="action-buttons ml-14">
                    <img class="w-24 h-24" :src="item.correspondence.hasRegularUserNew
                      ? require('@/assets/svg/hasnew.svg')
                      : require('@/assets/svg/hasnew-active.svg')
                      " />
                    <div class="fs-16 color---gray-400">
                      {{ formatDate(item.correspondence.last.date_created) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-124 mt-12">
                <div class="email-item-center flex row middle">
                  <div class="email-content mr-20">
                    <div class="email-title" v-if="item.correspondence.last.title" :class="item.correspondence.last.status === 'unread'
                      ? 'unread'
                      : ''
                      ">
                      {{ item.correspondence.last.title }}
                    </div>
                    <div class="email-snippet" :class="item.correspondence.last.status === 'unread'
                      ? 'unread'
                      : ''
                      ">
                      {{ stripHtmlTags(item.correspondence.last.content) }}
                    </div>
                    <div v-if="item.correspondence.hasAttachments" class="media-attachment">
                      <img src="@/assets/svg/link.svg" class="attachment-icon" alt="附件" />
                      <span>附件</span>
                    </div>
                  </div>
                  <div class="hoverDel pd-6 mr-12 mb-20 pointer round">
                    <img src="@/assets/svg/delete.svg" @click.stop="deleteSingleEmail(item)" alt="delete" />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-if="emailLoading">
            <div class="flex row middle center pb-40">
              <i class="el-icon-loading fs-24 color-black"></i>
              <div class="fs-14 color-gray ml-10">加载中...</div>
            </div>
          </li>
          <li v-if="!hasMore && emailList.length > 0 && !emailLoading">
            <div class="flex column center h-80">
              <div class="fs-14 color-gray">已加载全部数据</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="right-panel bg-lightgray3 pd-x-20 border-box" :style="{ width: rightWidth + '%' }">
      <!-- 邮件详情列表 -->
      <emailDetailList v-if="emailDetailListShow && selectedCorrespondenceInfo"
        :correspondenceInfo="selectedCorrespondenceInfo" :userInfo="selectedUserInfo" :currentUserInfo="checkItemInfo"
        @go-back="goBackToEmailList" @attachment-click="handleAttachmentFromDetail" />
    </div>
  </div>
</template>

<script>
import store from '@/store';

import {
  getConnectionsMails,
  getConnectionsMailsByXHR,
  changeEmailStar,
  updateEmailHasNew,
  getCorrespondenceEmailsHistory,
} from '@/api/talkytimes/message';

import emailDetailList from './components/emailDetailList.vue';
import {
  getOnlineStatus,
  getCorrespondenceStatistic,
} from '@/api/talkytimes/user';
import UserListSidebar from '@/components/UserListSidebar.vue';

export default {
  components: {
    emailDetailList,
    UserListSidebar,
  },
  data() {
    return {
      searchValue: '', // 搜索值
      total: 0, // 账号总数
      activeName: 'first', // 当前选中的tab
      currentEmailType: 1, // 当前选中的邮件类型
      checkItemInfo: {}, // 选中的账号
      emailList: [], // 邮件列表
      emailLoading: false, // 邮件列表加载状态
      pageSize: 15, // 每页显示数量
      pageNumTotal: 0, // 当前页数量
      hasMore: false, // 是否还有更多

      // 拖拽相关
      leftWidth: 20, // 左侧宽度百分比
      rightWidth: 80, // 右侧宽度百分比
      isDragging: false, // 是否正在拖拽
      startX: 0, // 拖拽开始的X坐标
      startLeftWidth: 0, // 拖拽开始时左侧宽度
      startRightWidth: 0, // 拖拽开始时右侧宽度

      // 邮件分类配置
      emailTabs: [
        { type: 1, label: '收件箱' },
        { type: 2, label: '受限的' },
        { type: 3, label: '已收藏' },
        { type: 4, label: 'VIP', icon: require('@/assets/icon/vip.png') },
        { type: 5, label: '发件箱' },
        { type: 6, label: '垃圾箱' },
      ],
      // 邮件类型映射
      emailTypeMapping: {
        1: 'inbox/',
        2: 'has_limits',
        3: 'starred',
        4: 'vip',
        5: 'outbox',
        6: 'trash',
      },
      // 工具栏相关
      selectAll: false,
      currentFilter: 'all',
      selectedEmails: [],
      emailDetailListShow: false, // 邮件详情列表显示
      selectedCorrespondenceInfo: null, // 选中的邮件对话信息
      selectedUserInfo: null, // 选中的用户信息
    };
  },
  activated() {
    // 移除 initData 调用，让 UserListSidebar 组件自动获取数据
  },
  mounted() { },
  computed: {
    // 获取用户列表，与 UserListSidebar 组件使用相同的数据源
    userList() {
      return this.$store.state.accountList.accountList || [];
    }
  },
  watch: {
    // 监听用户列表变化，当有数据时自动选择第一个用户
    userList: {
      handler(newUserList) {
        if (newUserList.length > 0 && !this.selectedUserInfo) {
          console.log('Email page - Auto selecting first user:', newUserList[0]);
          this.checkItem(newUserList[0]);
        }
      },
      immediate: true
    }
  },
  watch: {
    emailList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.updateOnlineStatus();
        }
      },
    },
  },
  methods: {
    updateOnlineStatus() {
      if (this.onlineQueryTimer) {
        clearTimeout(this.onlineQueryTimer);
        this.onlineQueryTimer = null;
      }
      let ids = this.emailList.map((item) => item.idRegularUser);
      getOnlineStatus({ ids }).then((res) => {
        console.log('在线状态：', res);
        this.emailList.forEach((item) => {
          let is_online =
            res[item.idRegularUser] !== undefined
              ? res[item.idRegularUser]
              : false;
          if (item.userDetail && item.userDetail.name && item.userDetail.age) {
            // 只有当userDetail完整时才更新在线状态
            item.userDetail.is_online = is_online;
          }
        });
      }).catch((error) => {
        // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，不显示错误提示
        if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
          console.log('在线状态查询失败（连接超时），静默处理');
          return;
        }
        // 其他错误也静默处理，在线状态查询失败不应该影响用户体验
        console.log('在线状态查询失败，静默处理:', error);
      });
      this.onlineQueryTimer = setTimeout(() => {
        this.updateOnlineStatus();
      }, 60000);
    },
    // 检查用户信息是否已加载完成
    isUserInfoLoaded(item) {
      return item.userDetail && item.userDetail.name && item.userDetail.age;
    },
    // 处理邮件项点击
    handleEmailItemClick(item) {
      // 如果用户信息还在加载中，不允许点击
      if (!this.isUserInfoLoaded(item)) {
        return;
      }
      this.getEmailDetailList(item);
    },
    getEmailDetailList(item) {
      console.log('item::::::', item);

      // 双重检查：如果用户信息未加载完成，不执行
      if (!this.isUserInfoLoaded(item)) {
        return;
      }

      // 设置选中的邮件对话信息和用户信息
      this.selectedCorrespondenceInfo = {
        id: item.id,
        idRegularUser: item.idRegularUser,
        idTrustedUser: item.idTrustedUser,
      };

      this.selectedUserInfo = item.userDetail || {};

      // 显示邮件详情列表
      this.emailDetailListShow = true;
    },

    emailClose() {
      this.emailShow = false;
    },

    // 回复邮件
    replyEmail() {
      if (!this.chatUserInfo) {
        this.$message.error('请先选择要回复的邮件');
        return;
      }
      // 清空邮件附件列表
      this.emailFileList = [];

      // 更新emailKey强制重新渲染sendEmail组件
      this.emailKey++;
      console.log('this.checkItemInfo::::::', this.checkItemInfo);
      const platformUserId = this.checkItemInfo.platformUserId,
        userId = this.chatUserInfo.userId,
        chatId = this.chatUserInfo.chatId;
      // 完全重置chatUserInfo对象
      this.chatUserInfo = {
        platformType: 'dating',
        platformUserId: platformUserId,
        userId: userId,
        token: this.checkItemInfo.token,
        chatId: chatId,
        // 展示信息，因为是我方回复邮件，所以展示我方的信息
        userDetail: {
          name: this.checkItemInfo.name || '',
          thumbnailUrl: this.checkItemInfo.personalAvatar_xl || '',
          platformUserId: platformUserId,
          platformType: 'dating',
          token: this.checkItemInfo.token,
        },
        emailContent: '',
        emailSubject: '',
      };
      this.emailType = 1; // 切换到发送模式
    },
    // 处理回复邮件事件
    handleReplyEmail() {
      this.replyEmail();
    },
    generatingEmail() {
      this.datingEmailLoading = true;
      generateEmailContent({
        chatId: this.chatUserInfo.chatId,
        platformType: 'dating',
        timestamp: new Date().getTime(),
        requestId: generateUUID(),
      });
    },
    // 处理附件上传
    handleAttachment() {
      this.emailFileFlag = true;
      this.attachmentShow = true;
    },
    sendEmailFn(data) {
      const dataInfo = JSON.parse(data);
      sendEmailMessage({
        chatId: this.chatUserInfo.chatId,
        cover: dataInfo.cover,
        subject: dataInfo.emailSubject,
        text: dataInfo.emailContent,
        attachments: dataInfo.attachments,
        platformType: 'dating',
        timestamp: new Date().getTime(),
        requestId: generateUUID(),
      });
      this.emailShow = false;
    },
    photoUrl(sender, recipient, basename) {
      return `https://api.dating.com/dialogs/usermedia/${recipient}/${sender}/${basename}.x400.scaleup.x1200.gallery?authorization=Token%20token=%22${this.checkItemInfo.token}%22`;
    },
    videoUrl(sender, recipient, basename) {
      return `https://api.dating.com/dialogs/usermedia/${recipient}/${sender}/${basename}.x.mp4?authorization=Token%20token=%22${this.checkItemInfo.token}%22`;
    },
    audioUrl(sender, recipient, basename) {
      return null;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      let d;
      // 检查是否为时间戳（数字）
      if (typeof dateStr === 'number' || /^\d+$/.test(dateStr)) {
        // 时间戳格式，直接创建Date对象
        d = new Date(parseInt(dateStr) * 1000); // 转换为毫秒
      } else {
        // 字符串格式，按原来的方式处理
        d = new Date(
          dateStr.replace(/-/g, '/').replace('T', ' ').replace(/\..*$/, '')
        );
      }
      if (isNaN(d.getTime())) return dateStr;

      const now = new Date();
      const currentYear = now.getFullYear();
      const dateYear = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      const hour = d.getHours().toString().padStart(2, '0');
      const minute = d.getMinutes().toString().padStart(2, '0');
      const second = d.getSeconds().toString().padStart(2, '0');

      // 如果是今年，不显示年份
      if (dateYear === currentYear) {
        return `${month}-${day} ${hour}:${minute}:${second}`;
      } else {
        // 不是今年，显示完整年月日时分秒
        return `${dateYear}-${month}-${day} ${hour}:${minute}:${second}`;
      }
    },
    // 移除 initData 方法，改为使用 UserListSidebar 组件自动获取数据
    checkItem(item) {
      console.log('checkItem called with:', item);

      // 处理用户数据，确保包含必要的字段
      const processedItem = {
        ...item,
        token: item.pdToken, // 获取token
        platformUserId: item.id,
        onLine: true,
      };

      console.log('Processed item:', processedItem);

      localStorage.setItem('activeUser', JSON.stringify(processedItem));

      // 设置选中的用户信息
      this.checkItemInfo = processedItem;
      this.selectedUserInfo = processedItem;

      // 重置邮件列表状态
      this.emailList = [];
      this.pageNumTotal = 0;
      this.hasMore = false;
      this.emailLoading = false;
      this.currentEmailType = 1; // 重置为收件箱

      // 获取邮件列表
      this.getEmailList();
    },
    handleEmailTabClick(type) {
      this.currentEmailType = type;
      // 重置邮件列表状态
      this.emailList = [];
      this.pageNumTotal = 0;
      this.hasMore = false;
      this.emailLoading = false;

      // 获取对应的邮件列表
      this.getEmailList();
    },
    getEmailList() {
      // 没有选中用户，不请求
      if (!this.checkItemInfo.platformUserId || !this.checkItemInfo.token) {
        return;
      }
      this.emailLoading = true;

      // 根据当前选中的邮件类型获取对应的邮件列表
      let emailType = '';
      if (this.currentEmailType === 1) {
        emailType =
          this.emailTypeMapping[this.currentEmailType] + this.currentFilter;
      } else {
        emailType = this.emailTypeMapping[this.currentEmailType];
      }
      // 使用 getConnectionsMails 获取其他类型的邮件
      const params = {
        type: emailType,
        idRegularUser: '',
        femaleIds: [this.checkItemInfo.platformUserId],
        offset: this.pageNumTotal,
        limit: this.pageSize,
      };

      getConnectionsMails(params).then(async (res) => {
        if (res && res.data && res.data.mails) {
          // 先显示邮件列表，不等待用户信息
          const emailsWithBasicInfo = res.data.mails.map(chat => ({
            ...chat,
            userId: chat.idRegularUser,
            platformUserId: chat.idUser,
            userDetail: null, // 先设置为null，后续异步加载
            platformUserDetail: null,
          }));

          this.emailList = [...this.emailList, ...emailsWithBasicInfo];
          console.log('this.emailList::::::', this.emailList);
          this.pageNumTotal += res.data.mails.length;
          // 如果返回的数据长度等于pageSize，说明可能还有更多数据
          this.hasMore = res.data.mails.length === this.pageSize;

          // 异步加载用户信息，不阻塞邮件列表显示
          this.loadUserInfoAsync(res.data.mails);
        } else {
          // 如果没有数据，设置hasMore为false
          this.hasMore = false;
        }
        this.emailLoading = false;
      });
    },
    loadMoreEmails() {
      console.log(
        'loadMoreEmails::::::',
        this.emailLoading,
        this.hasMore,
        this.checkItemInfo.platformUserId
      );
      // 防止重复加载
      if (
        this.emailLoading ||
        !this.hasMore ||
        !this.checkItemInfo.platformUserId
      ) {
        return;
      }
      this.getEmailList();
    },

    // 异步加载用户信息，不阻塞邮件列表显示
    async loadUserInfoAsync(mails) {
      try {
        // 异步获取用户信息
        const dialogsWithUserInfo = await store.dispatch(
          'userInfo/matchChatListUserInfo',
          { chatList: mails, userIdField: 'idRegularUser' }
        );

        // 批量更新邮件列表中的用户信息，确保数据完整性
        dialogsWithUserInfo.forEach((updatedMail) => {
          const index = this.emailList.findIndex(
            (mail) => mail.uid === updatedMail.uid
          );
          if (index !== -1) {
            // 确保userDetail数据完整后再更新
            if (updatedMail.userDetail && updatedMail.userDetail.name && updatedMail.userDetail.age) {
              // 使用Vue.set确保响应式更新
              this.$set(this.emailList[index], 'userDetail', updatedMail.userDetail);
              this.$set(this.emailList[index], 'platformUserDetail', updatedMail.platformUserDetail);
            } else {
              console.warn('用户信息不完整，跳过更新:', updatedMail.userDetail);
            }
          }
        });

        console.log('用户信息异步加载完成');
      } catch (error) {
        console.error('异步加载用户信息失败:', error);
      }
    },

    // 拖拽相关方法
    startResize(event) {
      this.isDragging = true;
      this.startX =
        event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
      this.startLeftWidth = this.leftWidth;
      this.startRightWidth = this.rightWidth;

      // 添加鼠标移动和释放事件监听器
      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
      document.addEventListener('touchmove', this.handleResize);
      document.addEventListener('touchend', this.stopResize);

      // 防止文本选择
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
      event.preventDefault();
    },

    handleResize(event) {
      if (!this.isDragging) return;

      const currentX =
        event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
      const deltaX = currentX - this.startX;
      const containerWidth =
        document.querySelector('.email-container').offsetWidth;
      const deltaPercent = (deltaX / containerWidth) * 100;

      // 计算新的宽度
      const newLeftWidth = Math.max(
        20,
        Math.min(60, this.startLeftWidth + deltaPercent)
      );
      const newRightWidth = 100 - newLeftWidth;

      // 确保两边都不会太小
      if (newLeftWidth >= 20 && newRightWidth >= 20) {
        this.leftWidth = newLeftWidth;
        this.rightWidth = newRightWidth;
      }
    },

    stopResize() {
      this.isDragging = false;

      // 移除事件监听器
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
      document.removeEventListener('touchmove', this.handleResize);
      document.removeEventListener('touchend', this.stopResize);

      // 恢复默认样式
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    },

    // 去除HTML标签的方法
    stripHtmlTags(html) {
      if (!html) return '';
      return html.replace(/<[^>]*>/g, '').trim();
    },

    // 工具栏相关方法
    handleSelectAll() {
      if (this.selectAll) {
        this.selectedEmails = [...this.emailList];
      } else {
        this.selectedEmails = [];
      }
    },

    setFilter(filter) {
      this.currentFilter = filter;
      // 重置邮件列表状态
      this.emailList = [];
      this.pageNumTotal = 0;
      this.hasMore = false;
      this.emailLoading = false;

      // 获取对应的邮件列表
      this.getEmailList();
    },

    handleMoreActions(command) {
      switch (command) {
        case 'markAsRead':
          this.updateRead(false);
          break;
        case 'markAsNew':
          this.updateRead(true);
          break;
      }
    },

    updateRead(hasNew) {
      if (this.selectedEmails.length === 0) {
        this.$message.warning('请先选择要标记的邮件');
        return;
      }
      let idUsers = this.selectedEmails.map((item) => item.idRegularUser);
      idUsers.forEach((idUser) => {
        updateEmailHasNew({
          idUser,
          update: {
            'correspondence.hasNew': hasNew,
          },
        }).then((res) => {
          // 更新页面上对应项的 correspondence.hasTrustedUserNew 属性
          this.selectedEmails.forEach((selectedEmail) => {
            const index = this.emailList.findIndex(
              (email) => email.idRegularUser === selectedEmail.idRegularUser
            );
            if (index !== -1) {
              this.$set(
                this.emailList[index].correspondence,
                'hasTrustedUserNew',
                hasNew
              );
            }
          });
          this.selectedEmails = [];
          this.selectAll = false;
        });
      });
    },

    deleteSelected() {
      if (this.selectedEmails.length === 0) {
        this.$message.warning('请先选择要删除的邮件');
        return;
      }
      this.$confirm('确定要删除选中的邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 执行删除操作
          console.log('删除选中的邮件:', this.selectedEmails);
          this.$message.success('删除成功');
          this.selectedEmails = [];
          this.selectAll = false;
        })
        .catch(() => {
          // 取消删除
        });
    },

    // 邮件选择相关方法
    toggleEmailSelection(item) {
      const index = this.selectedEmails.indexOf(item);
      if (index > -1) {
        this.selectedEmails.splice(index, 1);
      } else {
        this.selectedEmails.push(item);
      }

      // 更新全选状态
      this.selectAll = this.selectedEmails.length === this.emailList.length;
    },

    toggleStar(item) {
      if (item.isToggleStar) {
        return;
      }

      // 使用Vue.set确保响应式更新
      this.$set(item, 'isToggleStar', true);

      let type = item.isStarred ? 'unstar' : 'star',
        id = item.isStarred
          ? item.correspondence.last.id_correspondence
          : item.correspondence.last.id;

      changeEmailStar(type, id)
        .then((res) => {
          console.log('切换收藏状态:', res);
          item.isStarred = !item.isStarred;
        })
        .finally(() => {
          this.$set(item, 'isToggleStar', false);
        });
    },

    deleteSingleEmail(item) {
      this.$confirm('确定要删除这封邮件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 执行删除操作
          console.log('删除邮件:', item);
          updateEmailHasNew({
            idUser: item.idRegularUser,
            update: {
              'correspondence.isDeleted': true,
            },
          }).then((res) => {
            this.$message.success('删除成功');
            // 从列表中移除
            const index = this.emailList.indexOf(item);
            if (index > -1) {
              this.emailList.splice(index, 1);
            }
            // 从选中列表中移除
            const selectedIndex = this.selectedEmails.indexOf(item);
            if (selectedIndex > -1) {
              this.selectedEmails.splice(selectedIndex, 1);
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    },

    // 返回邮件列表
    goBackToEmailList() {
      this.emailDetailListShow = false;
      this.selectedCorrespondenceInfo = null;
      this.selectedUserInfo = null;
    },

    // 处理附件点击
    handleAttachmentFromDetail(attachmentData) {
      console.log('附件点击:', attachmentData);
      // 这里可以添加附件预览逻辑
      this.$message.info('附件预览功能开发中...');
    },
  },

  computed: {
    hasSelectedItems() {
      return this.selectedEmails.length > 0;
    },
  },

  beforeDestroy() {
    // 清理拖拽事件监听器
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
    document.removeEventListener('touchmove', this.handleResize);
    document.removeEventListener('touchend', this.stopResize);
  },
};
</script>

<style scoped lang="scss">
.custom-tabs {
  ::v-deep .el-tabs__item {
    color: #666666;

    &.is-active {
      color: #409eff;
    }

    &:hover {
      color: #409eff;
    }
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #409eff;
  }
}

.custom-sub-tabs {
  ::v-deep .el-tabs__item {
    color: #666666;
    font-size: 14px;

    &.is-active {
      color: #409eff;
    }

    &:hover {
      color: #409eff;
    }
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #409eff;
  }
}

// 空状态样式
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;

  .empty-content {
    text-align: center;
    color: #909399;

    .empty-icon {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;

      img {
        width: 56px;
        height: 56px;
        opacity: 0.8;
        filter: grayscale(20%) brightness(105%);
      }
    }

    .empty-title {
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 8px;
    }

    .empty-subtitle {
      font-size: 12px;
      color: #909399;
      line-height: 1.4;
    }
  }
}

// 加载状态样式
.loading-placeholder {
  color: #909399;
  font-size: 14px;

  .el-icon-loading {
    margin-right: 4px;
    font-size: 12px;
  }
}

// Element UI 无限滚动样式
.infinite-list {
  height: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  overflow: auto;

  .infinite-list-item {
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid transparent;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    cursor: pointer;

    &:hover {
      background: #f5f7fa;
    }

    // 确保内容正确显示
    >div {
      width: 100%;
    }
  }

  // 优化滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

// 邮件列表项样式 - 按照图片设计
.email-item-container {
  transition: all 0.2s ease;

  .email-checkbox {
    margin-right: 12px;

    .checkbox-label {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      input[type='checkbox'] {
        display: none;
      }

      .checkbox-mark {
        width: 16px;
        height: 16px;
        border: 1px solid #acb0b4;
        border-radius: 3px;
        position: relative;
        background: #fff;
        transition: all 0.2s ease;

        &:after {
          content: '';
          position: absolute;
          left: 5px;
          top: 1px;
          width: 4px;
          height: 8px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          opacity: 0;
          transition: opacity 0.2s ease;
        }
      }

      input:checked+.checkbox-mark {
        background: #007bff;
        border-color: #007bff;

        &:after {
          opacity: 1;
        }
      }
    }
  }

  .email-item-left {
    min-width: 200px;
    margin-right: 20px;
    cursor: pointer;

    .user-avatar-container {
      position: relative;
      margin-right: 12px;

      .user-avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
      }

      .online-indicator {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid #fff;

        &.online {
          background-color: #28a745;
        }

        &.offline {
          background-color: #6c757d;
        }
      }
    }
  }

  .email-item-center {
    min-width: 0;
    cursor: pointer;

    .email-content {
      .email-title {
        font-size: 16px;
        font-weight: 600;
        color: #6c757d;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        &.unread {
          color: #212529;
        }
      }

      .email-snippet {
        font-size: 14px;
        color: #6c757d;
        line-height: 1.4;
        margin-bottom: 8px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

        &.unread {
          color: #495057;
        }
      }

      .media-attachment {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #6c757d;
        background: #f8f9fa;
        padding: 4px 8px;
        border-radius: 4px;
        width: fit-content;

        .attachment-icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
  }

  .email-item-right {
    min-width: 120px;

    .action-buttons {
      display: flex;
      align-items: center;
      gap: 8px;

      .check-icon {
        color: #6c757d;
        font-size: 14px;
      }
    }
  }

  // 客户信息加载中时禁用点击
  &.loading-user-info {
    cursor: not-allowed !important;
    opacity: 0.6;
    pointer-events: none;

    .email-item-left,
    .email-item-center {
      cursor: not-allowed !important;
    }

    &:hover {
      background-color: transparent !important;
    }
  }
}

// 邮件工具栏样式
.email-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 16px;

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 20px;

    .select-all-checkbox {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      color: #495057;
      position: relative;

      input[type='checkbox'] {
        display: none;
      }

      .checkmark {
        width: 16px;
        height: 16px;
        border: 1px solid #acb0b4;
        border-radius: 3px;
        margin-right: 8px;
        position: relative;
        background: #fff;

        &:after {
          content: '';
          position: absolute;
          left: 5px;
          top: 1px;
          width: 4px;
          height: 8px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          opacity: 0;
        }
      }

      input:checked+.checkmark {
        background: #007bff;
        border-color: #007bff;

        &:after {
          opacity: 1;
        }
      }
    }

    .filter-buttons {
      display: flex;
      gap: 8px;

      .filter-btn {
        padding: 6px 16px;
        border: 1px solid #dee2e6;
        background: #fff;
        color: #495057;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: #f8f9fa;
        }

        &.active {
          background: #007bff;
          color: #fff;
          border-color: #007bff;
        }
      }
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

// 邀请信标签样式
.invite-tag {
  display: inline-block;
  background: #e6f7ff;
  color: #1890ff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #91d5ff;
  font-weight: normal;
}

// 邮件容器样式
.email-container {
  display: flex;
  margin-top: 8px;
  border-radius: 8px;
  position: relative;
  height: calc(100vh - 80px);

  .left-panel {
    min-width: 300px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .right-panel {
    flex: 1;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

// 拖拽条样式
.resize-handle {
  width: 8px;
  height: 100%;
  background: transparent;
  cursor: col-resize;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  z-index: 10;

  &:hover {
    background: rgba(64, 158, 255, 0.1);

    &::before {
      background: #409eff;
      opacity: 0.8;
    }
  }

  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 40px;
    background: #ddd;
    border-radius: 1px;
    transition: all 0.2s ease;
    opacity: 0.6;
  }

  &:active::before {
    background: #409eff;
    height: 60px;
    opacity: 1;
  }
}

// 邮件分类标签样式
.email-tabs-container {
  width: 100%;

  .email-tabs-scroll {
    width: 100%;
    height: 60px;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;

    .email-tab-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 70px;
      padding: 0 16px;
      height: 100%;
      flex-shrink: 0;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      &.active {
        .tab-content {
          color: #409eff;
        }

        .tab-line {
          background-color: #409eff;
          opacity: 1;
        }
      }

      .tab-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
        color: #666666;
        transition: color 0.3s ease;

        .tab-icon {
          width: 16px;
          height: 16px;
          object-fit: contain;
        }

        span {
          font-size: 15px;
          white-space: nowrap;
        }
      }

      .tab-line {
        width: 50px;
        height: 2px;
        border-radius: 0px 0px 0px 0px;
        background-color: #ddd;
        margin-top: 4px;
        opacity: 0;
        transition: all 0.3s ease;

        &.active {
          background-color: #409eff;
          opacity: 1;
        }
      }
    }
  }
}

.hoverDel {
  &:hover {
    background-color: rgba(51, 51, 51, 0.07);
  }
}
</style>
